export type UIDatasourceType =
  | "table"
  | "view"
  | "viewV2"
  | "query"
  | "custom"
  | "link"
  | "field"
  | "jsonarray"
